import React from 'react';
import {connectRefinementList} from 'react-instantsearch-dom';
import cx from 'classnames';
import {useOverlayThatClosesOnOutsideClick} from '../../hooks/useOverlayThatClosesOnOutsideClick';
import './RegionFilter.scss';
import {AP, BR, EU, EUNE, EUTR, EUW, JP, KR, LAN, LAS, LATM, NA, OCE, PBE, RU, TR} from "./regions-assets";

export const RegionFilter = connectRefinementList(
  ({
     items,
     refine,
     defaultRegions,
   }) => {
    const { isOpen, toggle, containerRef } = useOverlayThatClosesOnOutsideClick(
      { containerRef, isOpen, close: toggle }
    );

    const regions = {
      'NA': {icon: <NA/>, priority: 1},
      'EUW': {icon: <EUW/>, priority: 2},
      'EUNE': {icon: <EUNE/>, priority: 3},
      'EU': {icon: <EU/>, priority: 4},
      'EU-TR': {icon: <EUTR/>, priority: 5},
      'OCE': {icon: <OCE/>, priority: 6},
      'AP': {icon: <AP/>, priority: 7},
      'PBE': {icon: <PBE/>, priority: 8},
      'KR': {icon: <KR/>, priority: 9},
      'LAN': {icon: <LAN/>, priority: 10},
      'LAS': {icon: <LAS/>, priority: 11},
      'LATM': {icon: <LATM/>, priority: 12},
      'BR': {icon: <BR/>, priority: 13},
      'TR': {icon: <TR/>, priority: 14},
      'JP': {icon: <JP/>, priority: 15},
      'RU': {icon: <RU/>, priority: 16},
    }



    const displayRegion = (item) => {
      return regions[item.label].icon
    }

    // Filter out random ranks from the URL being passed into items array
    let sortedItems = Array.from(items).filter((item) => regions[item.label]).sort((a, b) => regions[a.label].priority - regions[b.label].priority)

    if (defaultRegions && items.length === 0) {
      sortedItems = defaultRegions.map((region) => {
        return {
          label: region,
          value: region,
          isRefined: false,
          count: 0
        }
      })
    }

    return (
      <div
        className="region-filter"
        ref={containerRef}
      >
          <div className="mb-4 flex gap-4">
              {sortedItems.map((item) => (
                  <div className={cx('region-filter__cards', item.isRefined && 'region-filter__cards-selected')}  onClick={() => { refine(item.value) }}
                       key={item.label}>
                      {displayRegion(item)}
                      <span className="region-filter__cards-region-text">{item.label}</span>
                  </div>
              ))}
          </div>
      </div>
    );
  }
);
